import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CrcModel } from "src/app/shared/models/crc.model";
import { ConfigManagerService } from './config-manager.service';

@Injectable({
  providedIn: "root",
})
export class CrcService {
  constructor(private http: HttpClient, private configManagerService: ConfigManagerService) {}
  validarCrcCpf(data: any, token: string) {
    const headers = new HttpHeaders().set("Authorization", `${token}`);
    const api = this.configManagerService.obterConfig()?.API_SOLICITATION;
    return this.http.post(
      `${api}/api/validacao/crc/cpf`,
      data,
      {
        headers,
      }
    );
  }
  validarCrcCnpj(data: any, token: string) {
    const headers = new HttpHeaders().set("Authorization", `${token}`);
    const api = this.configManagerService.obterConfig()?.API_SOLICITATION;
    return this.http.post(
      `${api}/api/validacao/crc/cnpj`,
      data,
      {
        headers,
      }
    );
  }
  BuscaCrc(url: any) {
    const api = this.configManagerService.obterConfig()?.API_SOLICITATION;
     return this.http.get<CrcModel>(
      `${api}/api/crc/BuscaCrc?url=${url}`
    );
  }
}
